import React, { useState, useEffect } from 'react';
import { CloudSun, Wind } from 'lucide-react';
import { CommanServices } from '@/services/commanServices';

// On-scene weather for an incident with GPS, resolved through the registered
// Open-Meteo API connection. Renders nothing when there's no GPS, no weather
// connection, or the lookup fails — purely additive.
const IncidentWeatherChip = ({ incidentId, hasGps = true }) => {
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    if (!incidentId || !hasGps) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await CommanServices.getIncidentWeather(incidentId);
        if (!cancelled && res?.status && res.data?.current_weather) setWeather(res.data.current_weather);
      } catch (e) { /* silent — chip simply doesn't render */ }
    })();
    return () => { cancelled = true; };
  }, [incidentId, hasGps]);

  if (!weather) return null;

  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full bg-sky-50 border border-sky-200 text-sky-700 text-[11px] font-semibold px-2.5 py-1"
      title="On-scene weather (Open-Meteo via API Connections)"
      data-testid="incident-weather-chip"
    >
      <CloudSun className="h-3.5 w-3.5" /> {Math.round(weather.temperature)}°C
      <Wind className="h-3 w-3 ml-0.5" /> {Math.round(weather.windspeed)} km/h
    </span>
  );
};

export default IncidentWeatherChip;
